"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const dispatcher_1 = require("../dispatcher");
function wrapObject(instance, options = {}) {
    const dispatcher = new dispatcher_1.Dispatcher();
    const ignores = options.ignores && new Set(options.ignores);
    dispatcher.context = new Proxy(instance, {
        set: function (obj, prop, value) {
            const previousVal = obj[prop];
            obj[prop] = value;
            if (typeof prop === "string" &&
                previousVal !== value &&
                (!ignores || !ignores.has(prop))) {
                dispatcher.dispatch([prop]);
                // else todo:
            }
            // Indicate success
            return true;
        }
    });
    return dispatcher;
}
exports.wrapObject = wrapObject;
//# sourceMappingURL=object-wrapper.js.map